import { SyntheticEvent, useCallback } from 'react';

export function useStopPropagation(callback: (evt: SyntheticEvent) => void) {
  return useCallback(
    (evt: SyntheticEvent) => {
      evt.stopPropagation();
      evt.preventDefault();

      callback(evt);
    },
    [callback]
  );
}
